import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import {
  handleLoginRequest,
  handleLoginSuccess,
  handleLoginFailure,
  handleLogout,
  handleRegisterRequest,
  handleRegisterSuccess,
  handleSuccess,
  handleEmployeeSteps,
  handleFailure,
  handleForgotPassword,
  handleNextPage,
  handleOtpRequest,
  resetOtpState,
  handleEmployeeEmailRequest,
  handleEmployeeOtpRequest,
  handleCreateEmployeeRequest,
  handleChangeSteps,
  handleSaveCompanyId,
  handleEmployeeLoginRequest,
  handleSaveUserType,
} from '../actions';
import { Auth } from '../constants/actionTypes';

export const initialState: Auth = {
  token: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  next: true,
  email: '',
  userType: '',
  employeeCreateSteps: 'email',
  companyId: 1,
};

const authReducer = createReducer(initialState, (builder: any) => {
  builder
    .addCase(handleLoginRequest, (state: Auth) => {
      state.loading = true;
    })
    .addCase(handleLoginSuccess, (state: Auth, action: PayloadAction<{ token: string, email: string }>) => {
      console.log('handleLoginSuccess', action.payload );
      state.loading = false;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.error = null;
      // state.next = true;
      // state.email = action.payload.email;
    })
    .addCase(
      handleLoginFailure,
      (state: Auth, action: PayloadAction<string>) => {
        state.loading = false;
        state.error = action.payload;
      },
    )
    .addCase(handleLogout, (state: Auth) => {
      state.isAuthenticated = false;
      state.token = null;
      state.error = null;
      state.loading = false;
    })
    .addCase(handleRegisterRequest, (state: Auth) => {
      state.loading = true;
    })
    .addCase(handleEmployeeEmailRequest, (state: Auth) => {
      state.loading = true;
    })
    .addCase(handleCreateEmployeeRequest, (state: Auth) => {
      state.loading = true;
    })
    .addCase(handleEmployeeLoginRequest, (state: Auth) => {
      state.loading = true;
    })
    .addCase(handleSaveCompanyId, (state: Auth, action: PayloadAction<number>) => {
      console.log('handleSaveCompanyId', action.payload);
      state.companyId = action.payload;
    })
    .addCase(handleSaveUserType, (state: Auth, action: PayloadAction<string>) => {
      // console.log('handleSaveCompanyId', action.payload);
      state.userType = action.payload;
    })
    .addCase(handleEmployeeSteps, (state: Auth, action: PayloadAction<{ steps: string, email: string }>) => {
      state.employeeCreateSteps = action.payload.steps;
      state.email = action.payload.email;
      state.next = true;
    })
    .addCase(handleChangeSteps, (state: Auth, action: PayloadAction<{ steps: string }>) => {
      state.employeeCreateSteps = action.payload.steps;
    })
    .addCase(handleOtpRequest, (state: Auth) => {
      state.loading = true;
    })
    .addCase(handleEmployeeOtpRequest, (state: Auth) => {
      state.loading = true;
    })
    .addCase(resetOtpState, (state: Auth) => {
      state.next = false;
      state.employeeCreateSteps = 'email';
    })
    .addCase(handleForgotPassword, (state: Auth) => {
      state.loading = true;
    })
    .addCase(handleRegisterSuccess, (state: Auth, action: PayloadAction<{ token: string }>) => {
      console.log('reducer', action.payload);
      state.loading = false;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.error = null;
      state.next = true;
    })
    .addCase(handleNextPage, (state: Auth) => {
      state.next = false;
    })
    .addCase(handleSuccess, (state: Auth) => {
      state.loading = false;
      state.error = null;
    })
    .addCase(handleFailure, (state: Auth, action: PayloadAction<string>) => {
      console.log('reducer failure', action.payload);
      state.loading = false;
      console.log('reducer', action.payload);
      state.error = action.payload;
    });
});

export default authReducer;
